import { SellerHasTournamentTicketListResponse } from "../../../../api/tournament-ticket";
import PointPaid from "./components/point-paid";

export interface PointPaidPopupProps {
  tournamentId: number;
  getData: () => void;
  onClose: () => void;
}

export interface PointPaidDto {
  rank: number; // 순위
  seedPrize: number; // 실질적 지급되는 시드 값
  carrotPrize?: number; // 실질적 지급되는 캐럿(CR) 값
  pointPrize?: number; // 실질적 지급되는 포인트 값
  nickname: string | null;
  memberId: number | null;
  payMent: boolean; // 지급 여부
  totalPrize: number; // 전체 프라이즈 합
  subPrize: SellerHasTournamentTicketListResponse | null; // 부상(티켓)
  subPrizeCount: number; // 부상 갯수
  isOpenSubPrize: boolean;
}

const PointPaidPopup = ({
  tournamentId,
  getData,
  onClose,
}: PointPaidPopupProps) => {
  // GTD, 데일리
  return (
    <PointPaid
      tournamentId={tournamentId}
      getData={getData}
      onClose={onClose}
    />
  );
};

export default PointPaidPopup;
